import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';

// localStorage.setItem('isLoggedIn', 'false')
// localStorage.setItem('name', 'unknown')
// localStorage.setItem('mobile', '')
// localStorage.setItem('wishlist', [])
// localStorage.setItem('cart', [])
// localStorage.setItem('buy', [])
// localStorage.setItem('yourOrders', [])
// localStorage.setItem('warning', 'false')
ReactDOM.render(<App/>, document.getElementById('root'))


